import React from "react";

interface Props {
  title: string;
  description: string;
}

const FooterText = ({ title, description }: Props) => {
  return (
    <div className="grid-module-blank grid-module--seo">
      <div className="cols-grid">
        <div className="cols-md--8 padded">
          <h2 className="header-3">{title}</h2>
          <p className="no-margin small">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default FooterText;
